<template>
  <div class="container-fild about">
    <h1 class="text-center">ABOUT ME</h1>
    <div class="row">
      <div class="col-lg-6 personal-info">
        <h3>PERSONAL INFOS</h3>
        <ul class="about-list list-unstyled">
          <li>
            <span class="title">Age: </span
            ><span
              class="
                value
                d-block d-sm-inline-block d-lg-block d-xl-inline-block
              "
            >
              {{ calculateAge }} Years</span
            >
          </li>
          <li>
            <span class="title">Nationality: </span
            ><span
              class="
                value
                d-block d-sm-inline-block d-lg-block d-xl-inline-block
              "
              >Egyptian</span
            >
          </li>
          <li>
            <span class="title">Travel: </span
            ><span
              class="
                value
                d-block d-sm-inline-block d-lg-block d-xl-inline-block
              "
              >Available</span
            >
          </li>
          <li>
            <span class="title">Address: </span
            ><span
              class="
                value
                d-block d-sm-inline-block d-lg-block d-xl-inline-block
              "
              >Alexandria - Egypt</span
            >
          </li>
          <li>
            <span class="title">phone: </span
            ><span
              class="
                value
                d-block d-sm-inline-block d-lg-block d-xl-inline-block
              "
              >+201013317307</span
            >
          </li>
          <li>
            <span class="title">Email: </span
            ><span
              class="
                value
                d-block d-sm-inline-block d-lg-block d-xl-inline-block
              "
              >ibrahimmosstafa11@gmail.com</span
            >
          </li>
        </ul>
      </div>
      <div class="col-xl-6 col-lg-6 col-12 mt-5 mt-lg-0">
        <div class="row">
          <div class="col-sm-6">
            <div class="box-stats with-margin">
              <h3 class="poppins-font position-relative">1</h3>
              <p class="open-sans-font m-0 position-relative text-uppercase">
                years of <span class="d-block">experience</span>
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="box-stats with-margin">
              <h3 class="poppins-font position-relative">20</h3>
              <p class="open-sans-font m-0 position-relative text-uppercase">
                completed <span class="d-block">projects</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="separator" />
    <!-- start skills -->
    <div class="skills">
      <h3 class="title text-center">SKILLS</h3>
      <div class="skills-page">
        <div class="progress-box">
          <h4 class="progress-title">HTML</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">CSS</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">BOOTSTRAP</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">SCSS</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">JAVASCRIPT</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">JQUERY</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 85%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              85%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">TAILWIND CSS</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 85%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              85%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">VUE.JS</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
        <div class="progress-box">
          <h4 class="progress-title">Nuxt 3</h4>
          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              aria-label="Example with label"
              style="width: 90%"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              90%
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end skills -->
    <hr class="separator" />
    <!-- start experience -->
    <!-- <div class="experience row">
      <h3 class="title">EXPERIENCE & EDUCATION</h3>
    </div>
    <div class="row">
      <div class="col-lg-6 resume-box">
        <ul>
          <li>
            <div class="icon">
              <font-awesome-icon
                icon="fa-solid fa-briefcase"
                size="lg"
                color="#ddd"
              />
            </div>
            <span class="time open-sans-font text-uppercase">
              Feb 2021 - Present</span
            >
            <h5 class="poppins-font text-uppercase">
              Front End
              <span class="place open-sans-font">Where2group </span>
            </h5>
            <p class="open-sans-font">
              Lorem ipsum dolor sit amet, consectetur tempor incididunt ut
              adipisicing elit
            </p>
          </li>
        </ul>
      </div>
      <div class="col-lg-6 resume-box">
        <ul>
          <li>
            <div class="icon">
              <font-awesome-icon
                icon="fa-solid fa-briefcase"
                size="lg"
                color="#ddd"
              />
            </div>
            <span class="time open-sans-font text-uppercase">
              Feb 2022 - Present</span
            >
            <h5 class="poppins-font text-uppercase">
              Front End
              <span class="place open-sans-font">FoxLaby</span>
            </h5>
            <p class="open-sans-font">
              Lorem ipsum dolor sit amet, consectetur tempor incididunt ut
              adipisicing elit
            </p>
          </li>
        </ul>
      </div>
    </div> -->
    <!-- end experience -->
  </div>
</template>

<script>
export default {
  name: "AboutPage",
  data() {
    return {};
  },
  components: {},
  computed: {
    calculateAge: function () {
      let currentDate = new Date();
      let birthDate = new Date("1995/9/29");
      let difference = currentDate - birthDate;
      let age = Math.floor(difference / 31557600000);
      return age;
    },
  },
};
</script>
